import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AccessDenied from '../jsx/pages/unauthorized/AccessDenied';

const PrivateRoute = ({ children, roles }) => {
    const navigate = useNavigate();
    const CurrentUser = useSelector(x => x.auth.user);
    
    const userTypeName = 
        CurrentUser.UserTypeID === 1 ? "SuperAdmin" :
        CurrentUser.UserTypeID === 2 ? "Admin" :
        CurrentUser.UserTypeID === 3 ? "OrderAnalyst" :
        CurrentUser.UserTypeID === 4 ? "Dispatcher" :
        CurrentUser.UserTypeID === 5 ? "WarehouseManager" :
        CurrentUser.UserTypeID === 6 ? "WarehouseAssistant" :
        CurrentUser.UserTypeID === 7 ? "Accountant" : 
        CurrentUser.UserTypeID === 8 ? "OpsAdmin":"";

    useEffect(() => {
        if (!roles && (userTypeName === "SuperAdmin" || userTypeName === "Admin" || userTypeName ==="OpsAdmin")) {
            navigate('/dashboard');
        } else if (!roles && userTypeName) {
            navigate('/ChangePassword');
        } else if (!roles) {
            localStorage.removeItem('user');
            navigate('/login');
        }
    }, [roles, userTypeName, navigate]);

    const userHasRequiredRole = roles && roles.includes(userTypeName);
    if (!userHasRequiredRole) {
        return <AccessDenied />; // your custom AccessDenied component
    }

    return children;
};

export default PrivateRoute;